module.exports = {
  title: 'Input Search Field',
  context: {
    placeholder: 'Search'
  }
}
